export default __webpack_public_path__ + "static/media/empty-cart.29a64572.svg";